import { BaseResource } from '@/modules/core/app/resources/BaseResource';
import { Route } from '@/modules/core/app/constants/api.constants';
import { EmbedUrl } from '@/modules/embedurl/models/EmbedUrl';

export class EmbedUrlResource extends BaseResource {
  getUrls(params: Params): Promise<EmbedUrl[]> {
    return this.getData(Route.EMBEDURLS_URLS, EmbedUrl, params);
  }
}

export default new EmbedUrlResource();
